module.exports = __webpack_public_path__ + "static/media/discover.9c770496.webp";